import { render } from "./CompBannerInvoices.vue?vue&type=template&id=31716ba4&scoped=true"
import script from "./CompBannerInvoices.vue?vue&type=script&lang=js"
export * from "./CompBannerInvoices.vue?vue&type=script&lang=js"

import "./CompBannerInvoices.vue?vue&type=style&index=0&id=31716ba4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31716ba4"]])

export default __exports__